import { TagOption } from 'components/shared/Tags/model';
import { TagBadge } from 'components/shared/underlyings/selector/multi/tag-badge';
import { Underlying } from 'models/underlying';
import { components, MultiValueGenericProps } from 'react-select';

type Props = Omit<MultiValueGenericProps<TagOption<Underlying>, true>, 'children' | 'data'> & {
  data: TagOption<Underlying>;
  canHighlight?: boolean;
  onTagHighlightToggled?: (labelToToggle: string) => void;
  onTagRemoved: (labelToRemove: string) => void;
};
export function MultiValueContainer({ data, canHighlight, onTagHighlightToggled, onTagRemoved, ...props }: Props) {
  return (
    <components.MultiValueContainer data={data} {...props}>
      <TagBadge
        className="d-flex m-1"
        key={data.label}
        value={data.rawValue}
        isDisabled={data.isDisabled ?? false}
        isHighlighted={data.isHighlighted ?? false}
        label={data.label}
        canHighlight={canHighlight}
        onTagHighlightToggled={onTagHighlightToggled}
        onTagRemoved={onTagRemoved}
      />
    </components.MultiValueContainer>
  );
}
